import { Button, Modal, notification } from "antd";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import GlobalContext from "../../../context/GlobalContext";
import axiosInstance from "../../../utils/axios";
import { useLoader } from "../../../context/LoaderContext";
import { updateActionAffaire } from "../../../api/geoprod";

const ModalAcceptRapporteur = () => {
  const { openModalAccepter, setOpenModalAccepter } = useContext(GlobalContext);
  const { setIsLoading } = useLoader();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const UpdateStatusRapporteur = async (etat) => {
    setOpenModalAccepter("")
    sessionStorage.setItem("consulter",false)
    const payload = {
      id_affaire: openModalAccepter.id_affaire,
      id_status:
        etat === "accepter"
          ? import.meta.env
              .VITE_APP_ID_STATUS_MISSION_PRISE_EN_CHARGE_PAR_RAPPORTEUR
          : import.meta.env
              .VITE_APP_ID_STATUS_MISSION_REJETEE_PAR_RAPPORTEUR,
    };

    const data = await updateActionAffaire(payload);
    if (data) {
      if (etat === "accepter") {
        axiosInstance
          .get(
            import.meta.env.VITE_APP_GEOPROD_API +
              "/get_info_specifique/" +
              openModalAccepter?.id_affaire,
            {
              headers: {
                Idsession: JSON.parse(sessionStorage.getItem("-x-token-user"))
                  ?.Acces_Token,
              },
            }
          )
          .then(async (res) => {
            setIsLoading(false);
            sessionStorage.setItem(
              "globalData",
              JSON.stringify(res?.data?.response?.data)
            );
            navigate("/formations/newHomologation", {
              state: {
                etat: "rappoprtAccepté",
                id_homologation: openModalAccepter?.id_affaire,
              },
            });
            setOpenModalAccepter("");
          })
          .catch(() => {
            setIsLoading(false);
            notification.error({
              message: t("Erreur"),
              description: "Erreur",
              duration: 0,
            });
          });
      } else {
        setOpenModalAccepter("");
        setIsLoading(false);
        window.location.reload();
      }
    }
  };

  return (
    <Modal
      open={openModalAccepter !== ""}
      footer={null}
      width={600}
      onCancel={() => setOpenModalAccepter("")}
    >
      <h4>
        {t(
          `Êtes-vous sûr de vouloir ${openModalAccepter?.etat} l'étude de cette demande ?`
        )}
      </h4>
      <Button
        type="primary"
        onClick={() => {
          setIsLoading(true);
          // if (openModalAccepter?.etat === "accepter") {
          //   UpdateStatusRapporteur("accpeter");
          // } else {
          //   UpdateStatusRapporteur("refuser");
          // }
          UpdateStatusRapporteur(openModalAccepter?.etat)
        }}
      >
        {t("Oui")}
      </Button>
      <Button
        type="primary"
        style={{ marginInline: "15px" }}
        onClick={() => setOpenModalAccepter("")}
      >
        {t("Non")}
      </Button>
    </Modal>
  );
};

export default ModalAcceptRapporteur;
